module.exports = __webpack_public_path__ + "static/dog-trainer-trick-e442668928a391ec4d0ce3870bad2ab6.png";